var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressBarOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 4,
    viewBox: "0 0 13 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 1.625C12.1875 2.53906 11.4512 3.25 10.5625 3.25C9.64844 3.25 8.9375 2.53906 8.9375 1.625C8.9375 0.736328 9.64844 0 10.5625 0C11.4512 0 12.1875 0.736328 12.1875 1.625ZM10.5625 1.01562C10.207 1.01562 9.95312 1.29492 9.95312 1.625C9.95312 1.98047 10.207 2.23438 10.5625 2.23438C10.8926 2.23438 11.1719 1.98047 11.1719 1.625C11.1719 1.29492 10.8926 1.01562 10.5625 1.01562ZM8.125 1.625C8.125 2.53906 7.38867 3.25 6.5 3.25C5.58594 3.25 4.875 2.53906 4.875 1.625C4.875 0.736328 5.58594 0 6.5 0C7.38867 0 8.125 0.736328 8.125 1.625ZM6.5 1.01562C6.14453 1.01562 5.89062 1.29492 5.89062 1.625C5.89062 1.98047 6.14453 2.23438 6.5 2.23438C6.83008 2.23438 7.10938 1.98047 7.10938 1.625C7.10938 1.29492 6.83008 1.01562 6.5 1.01562ZM0.8125 1.625C0.8125 0.736328 1.52344 0 2.4375 0C3.32617 0 4.0625 0.736328 4.0625 1.625C4.0625 2.53906 3.32617 3.25 2.4375 3.25C1.52344 3.25 0.8125 2.53906 0.8125 1.625ZM2.4375 2.23438C2.76758 2.23438 3.04688 1.98047 3.04688 1.625C3.04688 1.29492 2.76758 1.01562 2.4375 1.01562C2.08203 1.01562 1.82812 1.29492 1.82812 1.625C1.82812 1.98047 2.08203 2.23438 2.4375 2.23438Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarOthers);
export default __webpack_public_path__ + "static/media/ProgressBarOthers.9d65450876ea99d70fe2d8f961cd5ff7.svg";
export { ForwardRef as ReactComponent };